// The `refused_entitlement` build-target refusal (Flow 5, D65; docs/phase-0/
// slice5-ux-flows.md §8.3: "reuses RefusalCard.tsx verbatim - the exact precedent D65
// itself names"). VERIFIED GAP, not silently forced: `RefusalCard.tsx` renders
// hardcoded app-LIMIT copy ("You're at {plan}'s app limit" / "{appsUsed} of {appLimit}
// apps used") tied to `AppLimitRefusal`'s specific fields - reusing it verbatim for a
// runner-class/tier refusal (no app count involved at all) would show wrong, confusing
// text. The ux spec's own wording names this exact fallback ("...or a direct reuse of
// RefusalCard with new copy", slice5-ux-flows.md:870): this is that dedicated
// component, sharing RefusalCard's IDENTICAL visual composition
// (`.card.state-card.refusal`, `.actions`, never a blocking modal, never a price,
// "Back to your apps" always works) with entitlement-correct copy instead.
export const BuildTargetRefusalCard = ({
  requiredTier,
  onAskAboutUpgrading,
  onBackToApps,
}: {
  readonly requiredTier: string;
  readonly onAskAboutUpgrading: () => void;
  readonly onBackToApps: () => void;
}): React.JSX.Element => (
  <div className="card state-card refusal" role="region" aria-label="This build target needs a higher plan">
    <div className="h3">Building for this target needs {requiredTier}</div>
    <p className="muted">Your current plan doesn&apos;t include this build target&apos;s runner class.</p>
    <div className="actions">
      <button type="button" className="btn btn-primary" onClick={onAskAboutUpgrading}>
        Ask about upgrading
      </button>
    </div>
    <button type="button" className="btn btn-ghost btn-sm" onClick={onBackToApps}>
      Back to your apps
    </button>
  </div>
);
